// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-support-main-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 90vw;
  height: 100vh;
  background-color: #fff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1300;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.help-support-body-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* gap: 16px; */
  /* flex: 1 0 0; */
  align-self: stretch;
  height: 100vh;
}

.button-support-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
  outline: none;
  border: 1px solid transparent;
  background: transparent;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
}

.button-support-close:hover {
  background-color: #f1f5f9;
}

.button-support-close svg {
  pointer-events: none;
  width:20px;
  height: 20px;
  flex-shrink: 0;
  color: #64748b;
}

/* ── Dark mode ── */
.dark .help-support-main-container {
  background-color: #1e293b;
  box-shadow: -4px 0 20px rgba(0,0,0,0.4);
}

.dark .button-support-close:hover {
  background-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/helpAndSupportDrawer/helpAndSupportDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB;;kCAEgC;EAChC,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".help-support-main-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 90vw;\n  height: 100vh;\n  background-color: #fff;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n}\n\n.help-support-body-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  /* gap: 16px; */\n  /* flex: 1 0 0; */\n  align-self: stretch;\n  height: 100vh;\n}\n\n.button-support-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  transition:\n    background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out;\n  outline: none;\n  border: 1px solid transparent;\n  background: transparent;\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.button-support-close:hover {\n  background-color: #f1f5f9;\n}\n\n.button-support-close svg {\n  pointer-events: none;\n  width:20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: #64748b;\n}\n\n/* ── Dark mode ── */\n.dark .help-support-main-container {\n  background-color: #1e293b;\n  box-shadow: -4px 0 20px rgba(0,0,0,0.4);\n}\n\n.dark .button-support-close:hover {\n  background-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
